import script from "./MemorialSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./MemorialSelector.vue?vue&type=script&setup=true&lang=js"

import "./MemorialSelector.vue?vue&type=style&index=0&id=819892a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-819892a2"]])

export default __exports__